import { createSlice } from '@reduxjs/toolkit'
import { getDiditSessions, retryDiditSession } from 'redux-thunk/thunk/diditKyc.thunk'

const initialState = {
  diditSessions: null,
  levelStates: {},
  error: null
}

const {
  actions: { setDiditSessions },
  reducer
} = createSlice({
  name: 'didit',
  initialState,
  reducers: {
    setDiditSessions: (state, action) => ({
      ...state,
      diditSessions: action.payload,
      levelStates: action.payload?.levelStates || {},
      error: null
    })
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDiditSessions.pending, (state) => ({
        ...state,
        loading: true,
        error: null
      }))
      .addCase(getDiditSessions.fulfilled, (state, action) => ({
        ...state,
        loading: false,
        diditSessions: action?.payload,
        levelStates: action?.payload?.levelStates || {},
        error: null
      }))
      .addCase(getDiditSessions.rejected, (state, action) => ({
        ...state,
        loading: false,
        error: action.payload
      }))
      .addCase(retryDiditSession.pending, (state) => ({
        ...state,
        loading: true,
        error: null
      }))
      .addCase(retryDiditSession.fulfilled, (state, action) => ({
        ...state,
        loading: false,
        diditSessions: action?.payload,
        levelStates: action?.payload?.levelStates || {},
        error: null
      }))
      .addCase(retryDiditSession.rejected, (state, action) => ({
        ...state,
        loading: false,
        error: action.payload
      }))
  }
})

export { setDiditSessions }
export default reducer